module.exports = __webpack_public_path__ + "img/2.918de53c.png";